<template>
  <div class="about" :class="{ active: animate }">
      <div class="aboutHeader">
        <img
          src="../../../../assets/GST/gstFirst.jpg"
          alt="aboutHeader"
          id="aboutHeaderImage"
        />
      </div>
      <div class="top-left">
        <h1 class="drop-from-top">
          GST Solutions
        </h1>
        <p class="drop-from-bottom">
          Seamless GST Solutions: Simplifying Tax Compliance, Empowering Business Growth
        </p>
      </div>
    </div>
</template>

<script src="./first.js"></script>
<style src="./first.css"></style>
